export const tr = {
    'add-clients': 'todo'
};
